var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTiktokIconGray(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20503_559)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 6.5975V9.95917C15.9884 9.8092 14.547 9.24679 13.3333 8.33333V12.0833C13.3331 13.1009 13.0462 14.0979 12.5056 14.96C11.9649 15.8221 11.1924 16.5145 10.2764 16.9578C9.36042 17.4011 8.33809 17.5774 7.32654 17.4666C6.31499 17.3557 5.35513 16.9621 4.55692 16.3309C3.75871 15.6998 3.15445 14.8565 2.81336 13.8978C2.47226 12.939 2.40814 11.9036 2.62832 10.9101C2.84851 9.91658 3.34411 9.0052 4.05833 8.28035C4.77256 7.5555 5.67653 7.0465 6.66667 6.81167V10.4167C6.38257 10.6297 6.15766 10.9119 6.01328 11.2363C5.86891 11.5608 5.80986 11.9167 5.84175 12.2704C5.87364 12.6241 5.99541 12.9638 6.1955 13.2572C6.39559 13.5505 6.66735 13.7879 6.98497 13.9467C7.3026 14.1055 7.65555 14.1805 8.01031 14.1646C8.36507 14.1486 8.70986 14.0422 9.01194 13.8555C9.31402 13.6688 9.56337 13.408 9.7363 13.0978C9.90923 12.7877 10 12.4385 10 12.0833V2.5H13.4025C13.576 3.52367 14.0636 4.46802 14.7978 5.20219C15.532 5.93636 16.4763 6.42399 17.5 6.5975Z",
    stroke: "#AAAAAA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20503_559"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokIconGray);
export default __webpack_public_path__ + "static/media/tiktok-icon-gray.4d85c333ac5aefc9de39cd533e9a323a.svg";
export { ForwardRef as ReactComponent };